module.exports = __webpack_public_path__ + "static/media/chain-solution.ec18ec8d.png";